import React, { useEffect, useState } from "react";
import Layout from "../../Component/Layout";
import Select from "react-select";
import axios from "axios";
import { MASTER_API } from "../../apiConfig";
import { MdDelete } from "react-icons/md";

const PAGE_SIZE = 10;

function QualityConfiguration() {

    const [showModal, setShowModal] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);

    const [productTypes, setProductTypes] =
    useState([]);
const [processes, setProcesses] = useState([]);
   const [subProcesses, setSubProcesses] = useState([]);

    const [savedData, setSavedData] =
        useState([]);
        const [productTypeFilter, setProductTypeFilter] =
    useState("");

    const [viewMode, setViewMode] =
        useState(false);
        const [uoms, setUoms] =
    useState([]);

    const [isEditing, setIsEditing] =
        useState(false);

   const [formData, setFormData] =
    useState({
        qualityConfigId: null,

        productType: "",
        processId: "",
        processName: "",
        subProcessId: "",
        subProcessName: "",

       rows: [
    {
        characteristic: "",
        uom: "",
        configurationType: "Both"
    }
]
    });

    useEffect(() => {

    fetchProductTypes();
    fetchSavedConfigurations();
    fetchUoms();
fetchProcesses();
}, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [productTypeFilter]);

    const customSelectStyles = {
    control: (base) => ({
        ...base,
        minHeight: 32,
        height: 32,
        fontSize: '13px',
        borderColor: '#dee2e6',
        boxShadow: 'none'
    }),

    valueContainer: (base) => ({
        ...base,
        padding: '0 8px',
        height: '32px',
        display: 'flex',
        alignItems: 'center'
    }),

    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0
    }),

    dropdownIndicator: (base) => ({
        ...base,
        padding: 4
    }),

  menu: (base) => ({
    ...base,
    fontSize: "13px",
    zIndex: 9999,
    maxHeight: "180px"
}),

menuList: (base) => ({
    ...base,
    maxHeight: "180px"
}),

menuPortal: (base) => ({
    ...base,
    zIndex: 99999
}),
};

const fetchProcesses = async () => {

    try {

        const res = await axios.get(
            `${MASTER_API}/quality-configuration/processes`
        );

        setProcesses(res.data || []);

    } catch (err) {

        console.error(err);
    }
};
const fetchProductTypes = async () => {

    try {

        const res = await axios.get(
            `${MASTER_API}/configuration/product-types`
        );

        setProductTypes(res.data || []);

    } catch (err) {

        console.error(err);
    }
};


const fetchUoms = async () => {

    try {

        const res = await axios.get(
            `${MASTER_API}/configuration/uom`
        );

        setUoms(res.data || []);

    } catch (err) {

        console.error(err);
    }
};
    

    const getOptions = (list) => {

    if (!list) return [];

    return list.map(item => ({

        value:
            item.group_name ||
            item.name ||
            item.uom_name ||
            item.uom,

        label:
            item.group_name ||
            item.name ||
            item.uom_name ||
            item.uom

    }));
};

    const handleRowChange = (
        index,
        field,
        value
    ) => {

        const updated =
            [...formData.rows];

        updated[index][field] = value;

        setFormData({
            ...formData,
            rows: updated
        });
    };

    const addRow = () => {

        setFormData({
            ...formData,
            rows: [
                ...formData.rows,
               {
    characteristic: "",
    uom: "",
    configurationType: "Both"
}
            ]
        });
    };



    const fetchSavedConfigurations = async () => {
    try {

        const res = await axios.get(
            `${MASTER_API}/quality-configuration/all`
        );

        console.log("ALL DATA => ", res.data);

        setSavedData(res.data || []);

    } catch (err) {
        console.error(err);
    }
};
    const deleteRow = (index) => {

        const updatedRows =
            formData.rows.filter(
                (_, i) => i !== index
            );

        setFormData({
            ...formData,
            rows:
                updatedRows.length > 0
                    ? updatedRows
                    : [
                        {
    characteristic: "",
    uom: "",
    configurationType: "Both"
}
                    ]
        });
    };

   const handleSave = async () => {

    try {

        if(formData.qualityConfigId){

            await axios.put(
                `${MASTER_API}/quality-configuration/update/${formData.qualityConfigId}`,
                formData
            );

        } else {

            await axios.post(
                `${MASTER_API}/quality-configuration/create`,
                formData
            );
        }

        alert("Saved Successfully");

        fetchSavedConfigurations();

        setShowModal(false);

        setViewMode(false);

        setIsEditing(false);

    } catch (err) {

        console.error(err);

        alert(
            err?.response?.data?.message ||
            "Failed to save"
        );
    }
};


const checkDuplicate = async (
    productType,
    processId,
    subProcessId = ""
) => {
    console.log("CHECKING:", { productType, processId, subProcessId }); // ← ADD THIS

    try {
        const res = await axios.post(
    `${MASTER_API}/quality-configuration/check-duplicate`,
    {
        productType,
        processId,
        processName: formData.processName,
        subProcessId
    }
);

        console.log("RESULT:", res.data); // ← ADD THIS

        if (res.data.exists) {
            alert("Process already exists for this Product Type");
            return true;
        }

        return false;

    } catch (err) {
        console.error(err);
        return false;
    }
};
    const handleProcessChange = (selected) => {

    const process = processes.find(
        p => p.process_id == selected?.value
    );

    setFormData(prev => ({
        ...prev,
        processId: process?.process_id || "",
        processName: process?.process_name || "",
        subProcessId: "",
        subProcessName: ""
    }));

    const filtered = processes.filter(
        p => p.process_id === process?.process_id
    );

    setSubProcesses(filtered);
};

    const handleView = async (item) => {

        try {

           const res = await axios.get(
    `${MASTER_API}/quality-configuration/view/${item.quality_config_id}`
);

      setFormData({
    qualityConfigId:
        res.data[0]?.quality_config_id || null,

    productType: res.data[0]?.product_type || "",
    processId: res.data[0]?.process_id || "",
    processName: res.data[0]?.process_name || "",
    subProcessId: res.data[0]?.sub_process_id || "",
    subProcessName: res.data[0]?.sub_process_name || "",

  rows: res.data.map(row => ({
    characteristic: row.characteristic,
    uom: row.uom,
    configurationType:
        row.configuration_type || "Both"
}))
});


            setViewMode(true);

            setIsEditing(false);

            setShowModal(true);

        } catch (err) {

            console.error(err);
        }
    };

    const handleDelete = async (item) => {

    const ok = window.confirm(
        "Are you sure you want to delete?"
    );

    if (!ok) return;

    try {

        await axios.delete(
            `${MASTER_API}/quality-configuration/delete/${item.quality_config_id}`
        );

        alert("Deleted Successfully");

        fetchSavedConfigurations();

    } catch (err) {

        console.error(err);

        alert("Delete Failed");
    }
};

    const filteredData = productTypeFilter
    ? savedData.filter(
          item =>
              item.product_type?.toLowerCase() ===
              productTypeFilter.toLowerCase()
      )
    : savedData;

    const totalPages =
        Math.max(1, Math.ceil(filteredData.length / PAGE_SIZE));

    const safeCurrentPage = Math.min(currentPage, totalPages);

    const paginatedData = filteredData.slice(
        (safeCurrentPage - 1) * PAGE_SIZE,
        safeCurrentPage * PAGE_SIZE
    );

    return (

        <Layout>

            <div style={styles.pageTitleBar}>

                <div>

                    <h1 style={styles.pageTitle}>
                        Quality Configuration
                    </h1>

                    <p style={styles.pageSubtitle}>
                        Manage Quality Configurations
                    </p>

                </div>

                <button
                    style={styles.createBtn}
                    onClick={() => {

    setViewMode(false);

    setIsEditing(true);

    setFormData({
        qualityConfigId: null,   // IMPORTANT

        productType: "",
        processId: "",
        processName: "",
        subProcessId: "",
        subProcessName: "",

       rows: [
    {
        characteristic: "",
        uom: "",
        configurationType: "Both"
    }
]
    });

    setShowModal(true);
}}
                >
                    + Create
                </button>

            </div>

          <div style={styles.tableWrapper}>

    <div className="row mb-3">
        <div className="col-md-3">
            <label style={styles.label}>
                Product Type Filter
            </label>

            <Select
                styles={customSelectStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                isClearable
                placeholder="All Product Types"
                options={productTypes.map(item => ({
                    value: item.name,
                    label: item.name
                }))}
                value={
                    productTypeFilter
                        ? {
                              value: productTypeFilter,
                              label: productTypeFilter
                          }
                        : null
                }
                onChange={(selected) =>
                    setProductTypeFilter(
                        selected?.value || ""
                    )
                }
            />
        </div>
    </div>

    <div style={styles.tableContainer}>

    <table
        className="table"
        style={styles.erpTable}
    >

        <thead>

                            <tr>

                           

<th style={styles.erpTh}>
    Product Type
</th>

<th style={styles.erpTh}>
    Process ID
</th>

<th style={styles.erpTh}>
    Process
</th>

<th style={styles.erpTh}>
    Sub Process ID
</th>

<th style={styles.erpTh}>
    Sub Process
</th>

<th
    style={styles.erpTh}
    width="120"
>
    Action
</th>

                            </tr>

        </thead>

        <tbody>

            {paginatedData.length > 0 ? (

                paginatedData.map((item, index) => (

                    <tr key={index}>

                       

<td style={styles.erpTd}>
    {item.product_type}
</td>

<td style={styles.erpTd}>
    {item.process_id || "-"}
</td>

<td style={styles.erpTd}>
    {item.process_name || "-"}
</td>

<td style={styles.erpTd}>
    {item.sub_process_id || "-"}
</td>

<td style={styles.erpTd}>
    {item.sub_process_name || "-"}
</td>

                       

                       <td style={styles.erpTd}>

    <div
        style={{
            display: "flex",
            alignItems: "center",
            gap: "8px"
        }}
    >

        <button
            className="btn btn-outline-dark btn-sm"
            style={{
                fontSize: "11px",
                padding: "2px 8px"
            }}
            onClick={() =>
                handleView(item)
            }
        >
            View
        </button>
<button
    type="button"
    onClick={() => handleDelete(item)}
    title="Delete"
    style={{
        border: "none",
        background: "transparent",
        color: "#dc2626",
        cursor: "pointer",
        padding: "0 4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }}
>
    <MdDelete size={18} />
</button>

    </div>

</td>

                    </tr>

                ))

            ) : (

                <tr>

                                        <td
    colSpan="7"
    className="text-center text-muted p-3"
>
                        No Quality Configurations Found
                    </td>

                </tr>

            )}

        </tbody>

    </table>

</div>

{filteredData.length > 0 && (

    <div
        style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "14px 4px 4px"
        }}
    >

        <span style={{ color: "#555", fontSize: "14px" }}>
            Page <strong>{safeCurrentPage}</strong> of{" "}
            <strong>{totalPages}</strong>
        </span>

        <div style={{ display: "flex", gap: "8px" }}>

            <button
                disabled={safeCurrentPage === 1}
                onClick={() =>
                    setCurrentPage(p => Math.max(1, p - 1))
                }
                style={{
                    padding: "6px 16px",
                    borderRadius: "6px",
                    border: "1px solid #d0d5dd",
                    background: safeCurrentPage === 1 ? "#f5f6f8" : "#fff",
                    color: safeCurrentPage === 1 ? "#a0a4ab" : "#333",
                    cursor:
                        safeCurrentPage === 1
                            ? "not-allowed"
                            : "pointer",
                    fontSize: "14px"
                }}
            >
                Prev
            </button>

            <button
                disabled={safeCurrentPage === totalPages}
                onClick={() =>
                    setCurrentPage(p => Math.min(totalPages, p + 1))
                }
                style={{
                    padding: "6px 16px",
                    borderRadius: "6px",
                    border: "1px solid #d0d5dd",
                    background:
                        safeCurrentPage === totalPages
                            ? "#f5f6f8"
                            : "#fff",
                    color:
                        safeCurrentPage === totalPages
                            ? "#a0a4ab"
                            : "#333",
                    cursor:
                        safeCurrentPage === totalPages
                            ? "not-allowed"
                            : "pointer",
                    fontSize: "14px"
                }}
            >
                Next
            </button>

        </div>

    </div>

)}

            </div>

            {showModal && (

    <div style={styles.modalBackdrop}>

        <div style={styles.modal}>

            <div style={styles.modalHeader}>

                <h5 style={{ margin: 0 }}>
                    Quality Configuration
                </h5>

                <button
                    onClick={() => setShowModal(false)}
                    style={styles.closeBtn}
                >
                    ✖
                </button>

            </div>

            <div style={styles.modalBody}>

                <div className="row mb-4">

                    <div className="col-md-4">

                        <label style={styles.label}>
                            Product Type
                        </label>

                        <Select
                            styles={customSelectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            isClearable
                            options={productTypes.map(item => ({
                                value: item.name,
                                label: item.name
                            }))}
                            isDisabled={!isEditing}
                            value={
                                formData.productType
                                    ? {
                                        value: formData.productType,
                                        label: formData.productType
                                    }
                                    : null
                            }
                            onChange={(selected) =>
                                setFormData({
                                    ...formData,
                                    productType: selected?.value || ""
                                })
                            }
                        />

                    </div>
{formData.productType?.toLowerCase() === "finished goods" && (

<>
    <div className="col-md-4">

        <label style={styles.label}>
            Process ID
        </label>

        <Select
            styles={customSelectStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            options={[
    ...new Map(
        processes.map(item => [
            item.process_id,
            { value: item.process_id, label: item.process_id }
        ])
    ).values()
]}
            value={
                formData.processId
                    ? {
                          value: formData.processId,
                          label: formData.processId
                      }
                    : null
            }
            onChange={async (selected) => {

                const process = processes.find(
                    p => p.process_id == selected?.value
                );

                if (!process) return;

                // Check duplicate for process alone (sub-process not selected yet)
                // const isDuplicate = await checkDuplicate(
                //     formData.productType,
                //     process.process_id
                // );

                // if (isDuplicate) {
                //     setFormData(prev => ({
                //         ...prev,
                //         processId: "",
                //         processName: "",
                //         subProcessId: "",
                //         subProcessName: ""
                //     }));
                //     setSubProcesses([]);
                //     return;
                // }

                const filteredSubProcesses = processes.filter(
                    p => p.process_id === process.process_id
                );

                setSubProcesses(filteredSubProcesses);

                setFormData(prev => ({
                    ...prev,
                    processId: process.process_id || "",
                    processName: process.process_name || "",
                    subProcessId: "",
                    subProcessName: ""
                }));
            }}
        />

    </div>

    <div className="col-md-4">

        <label style={styles.label}>
            Process
        </label>

        <Select
            styles={customSelectStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
           options={[
    ...new Map(
        processes.map(item => [
            item.process_name,
            { value: item.process_name, label: item.process_name }
        ])
    ).values()
]}
            value={
                formData.processName
                    ? {
                          value: formData.processName,
                          label: formData.processName
                      }
                    : null
            }
            onChange={async (selected) => {

                const process = processes.find(
                    p => p.process_name == selected?.value
                );

                if (!process) return;

                // Check duplicate for process alone (sub-process not selected yet)
                // const isDuplicate = await checkDuplicate(
                //     formData.productType,
                //     process.process_id
                // );

                // if (isDuplicate) {
                //     setFormData(prev => ({
                //         ...prev,
                //         processId: "",
                //         processName: "",
                //         subProcessId: "",
                //         subProcessName: ""
                //     }));
                //     setSubProcesses([]);
                //     return;
                // }

                const filteredSubProcesses = processes.filter(
                    p => p.process_id === process.process_id
                );

                setSubProcesses(filteredSubProcesses);

                setFormData(prev => ({
                    ...prev,
                    processId: process.process_id || "",
                    processName: process.process_name || "",
                    subProcessId: "",
                    subProcessName: ""
                }));
            }}
        />

    </div>

    <div className="col-md-4">
        <label style={styles.label}>Sub Process ID</label>
        <Select
            styles={customSelectStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            isClearable
            options={subProcesses.map(item => ({
                value: item.sub_process_id,
                label: item.sub_process_id
            }))}
            isDisabled={!formData.processId}
            value={
                formData.subProcessId
                    ? { value: formData.subProcessId, label: formData.subProcessId }
                    : null
            }
            onChange={async (selected) => {
                const subProcess = subProcesses.find(
                    p => p.sub_process_id === selected?.value
                );
                const isDuplicate = await checkDuplicate(
                    formData.productType,
                    formData.processId,
                    subProcess?.sub_process_id || ""
                );
                if (isDuplicate) {
                    setFormData(prev => ({
                        ...prev,
                        subProcessId: "",
                        subProcessName: ""
                    }));
                    return;
                }
                setFormData(prev => ({
                    ...prev,
                    subProcessId: subProcess?.sub_process_id || "",
                    subProcessName: subProcess?.sub_process_name || ""
                }));
            }}
        />
    </div>

    <div className="col-md-4">
        <label style={styles.label}>Sub Process</label>
        <Select
            styles={customSelectStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            isClearable
            options={subProcesses.map(item => ({
                value: item.sub_process_name,
                label: item.sub_process_name
            }))}
            isDisabled={!formData.processId}
            value={
                formData.subProcessName
                    ? { value: formData.subProcessName, label: formData.subProcessName }
                    : null
            }
            onChange={async (selected) => {
                const subProcess = subProcesses.find(
                    p => p.sub_process_name === selected?.value
                );
                const isDuplicate = await checkDuplicate(
                    formData.productType,
                    formData.processId,
                    subProcess?.sub_process_id || ""
                );
                if (isDuplicate) {
                    setFormData(prev => ({
                        ...prev,
                        subProcessId: "",
                        subProcessName: ""
                    }));
                    return;
                }
                setFormData(prev => ({
                    ...prev,
                    subProcessId: subProcess?.sub_process_id || "",
                    subProcessName: subProcess?.sub_process_name || ""
                }));
            }}
        />
    </div>
</>

)}
{formData.productType?.toLowerCase() === "semi finished" && (

<>
    <div className="col-md-4">

        <label style={styles.label}>
            Process ID
        </label>

        <Select
            styles={customSelectStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            options={processes.map(item => ({
                value: item.process_id,
                label: item.process_id
            }))}
            value={
                formData.processId
                    ? {
                        value: formData.processId,
                        label: formData.processId
                    }
                    : null
            }
            onChange={async (selected) => {

                const process = processes.find(
                    p => p.process_id == selected?.value
                );

                if (!process) return;

                // Check duplicate for process alone (sub-process not selected yet)
                // const isDuplicate = await checkDuplicate(
                //     formData.productType,
                //     process.process_id
                // );

                // if (isDuplicate) {
                //     setFormData(prev => ({
                //         ...prev,
                //         processId: "",
                //         processName: "",
                //         subProcessId: "",
                //         subProcessName: ""
                //     }));
                //     setSubProcesses([]);
                //     return;
                // }

                const filteredSubProcesses = processes.filter(
                    p => p.process_id === process.process_id
                );

                setSubProcesses(filteredSubProcesses);

                setFormData(prev => ({
                    ...prev,
                    processId: process.process_id || "",
                    processName: process.process_name || "",
                    subProcessId: "",
                    subProcessName: ""
                }));
            }}
        />

    </div>

    <div className="col-md-4">

        <label style={styles.label}>
            Process
        </label>

        <Select
            styles={customSelectStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            options={processes.map(item => ({
                value: item.process_name,
                label: item.process_name
            }))}
            value={
                formData.processName
                    ? {
                        value: formData.processName,
                        label: formData.processName
                    }
                    : null
            }
            onChange={(selected) => {

                const process = processes.find(
                    p => p.process_name === selected?.value
                );

                if (!process) return;

                const filteredSubProcesses = processes.filter(
                    p => p.process_id === process.process_id
                );

                setSubProcesses(filteredSubProcesses);

                setFormData(prev => ({
                    ...prev,
                    processId: process.process_id || "",
                    processName: process.process_name || "",
                    subProcessId: "",
                    subProcessName: ""
                }));
            }}
        />

    </div>

    <div className="col-md-4">

        <label style={styles.label}>
            Sub Process ID
        </label>

        <Select
            styles={customSelectStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            options={subProcesses.map(item => ({
                value: item.sub_process_id,
                label: item.sub_process_id
            }))}
            value={
                formData.subProcessId
                    ? {
                        value: formData.subProcessId,
                        label: formData.subProcessId
                    }
                    : null
            }
            onChange={async (selected) => {

                const subProcess = subProcesses.find(
                    p => p.sub_process_id === selected?.value
                );

                const isDuplicate = await checkDuplicate(
                    formData.productType,
                    formData.processId,
                    subProcess?.sub_process_id || ""
                );

                if (isDuplicate) {
                    setFormData(prev => ({
                        ...prev,
                        subProcessId: "",
                        subProcessName: ""
                    }));
                    return;
                }

                setFormData(prev => ({
                    ...prev,
                    subProcessId: subProcess?.sub_process_id || "",
                    subProcessName: subProcess?.sub_process_name || ""
                }));
            }}
        />

    </div>

    <div className="col-md-4">

        <label style={styles.label}>
            Sub Process
        </label>

        <Select
            styles={customSelectStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            options={subProcesses.map(item => ({
                value: item.sub_process_name,
                label: item.sub_process_name
            }))}
            value={
                formData.subProcessName
                    ? {
                        value: formData.subProcessName,
                        label: formData.subProcessName
                    }
                    : null
            }
            onChange={async (selected) => {

                const subProcess = subProcesses.find(
                    p => p.sub_process_name === selected?.value
                );

                const isDuplicate = await checkDuplicate(
                    formData.productType,
                    formData.processId,
                    subProcess?.sub_process_id || ""
                );

                if (isDuplicate) {
                    setFormData(prev => ({
                        ...prev,
                        subProcessId: "",
                        subProcessName: ""
                    }));
                    return;
                }

                setFormData(prev => ({
                    ...prev,
                    subProcessId: subProcess?.sub_process_id || "",
                    subProcessName: subProcess?.sub_process_name || ""
                }));
            }}
        />

    </div>

</>

)}
                </div>

                <div className="row mb-2">

                   <div className="col-md-4">
    <label style={styles.label}>
        Parameters
    </label>
</div>

<div className="col-md-3">
    <label style={styles.label}>
        UOM
    </label>
</div>

<div className="col-md-3">
    <label style={styles.label}>
        Type Of Configuration
    </label>
</div>

                </div>

                {formData.rows.map((row, index) => (

                    <div
                        className="row g-3 mb-2"
                        key={index}
                    >

                        <div className="col-md-4">

                            <input
                                className="form-control"
                                style={{
                                    height: "32px",
                                    minHeight: "32px",
                                    fontSize: "13px"
                                }}
                                disabled={!isEditing}
                                placeholder="Enter parameter"
                                value={row.characteristic}
                                onChange={(e) =>
                                    handleRowChange(
                                        index,
                                        "characteristic",
                                        e.target.value
                                    )
                                }
                            />

                        </div>

           <div className="col-md-3">

    <Select
        styles={customSelectStyles}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        isClearable
        options={getOptions(uoms)}
        isDisabled={!isEditing}
        value={
            row.uom
                ? {
                    value: row.uom,
                    label: row.uom
                }
                : null
        }
        onChange={(selected) =>
            handleRowChange(
                index,
                "uom",
                selected?.value || ""
            )
        }
    />

</div>

<div className="col-md-3">

    <Select
        styles={customSelectStyles}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        isDisabled={!isEditing}
        value={{
            value: row.configurationType || "Both",
            label: row.configurationType || "Both"
        }}
        options={[
            {
                value: "Inspection",
                label: "Inspection"
            },
            {
                value: "GTP",
                label: "GTP"
            },
            {
                value: "Both",
                label: "Both"
            }
        ]}
        onChange={(selected) =>
            handleRowChange(
                index,
                "configurationType",
                selected?.value || "Both"
            )
        }
    />

</div>

{isEditing && (

    <div className="col-md-2 d-flex align-items-end gap-2">

                                <button
                                    type="button"
                                    style={styles.addBtn}
                                    onClick={addRow}
                                >
                                    +
                                </button>

                                <button
                                    type="button"
                                    style={styles.deleteBtn}
                                    onClick={() =>
                                        deleteRow(index)
                                    }
                                >
                                    -
                                </button>

                            </div>

                        )}

                    </div>

                ))}

            </div>

            <div style={styles.modalFooter}>

                {!isEditing && (

                    <button
                        style={styles.editBtn}
                        onClick={() => {
                            setViewMode(false);
                            setIsEditing(true);
                        }}
                    >
                        Edit
                    </button>

                )}

                {isEditing && (

                    <button
                        style={styles.saveBtn}
                        onClick={handleSave}
                        disabled={!formData.productType}
                    >
                        Save
                    </button>

                )}

            </div>

        </div>

    </div>

)}

        </Layout>
    );
}

const styles = {
    tableContainer: {
    background: "#fff",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
},

erpTable: {
    marginBottom: 0
},

erpTh: {
    background: "#f8fafc",
    color: "#334155",
    fontWeight: 600,
    fontSize: "13px",
    padding: "12px",
    borderBottom: "1px solid #e2e8f0"
},

erpTd: {
    fontSize: "13px",
    color: "#334155",
    padding: "10px 12px",
    verticalAlign: "middle"
},

    pageTitleBar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px"
    },

    pageTitle: {
        fontSize: "30px",
        fontWeight: 700
    },

    pageSubtitle: {
        fontSize: "12px",
        color: "#64748b"
    },

    tableWrapper: {
        background: "#fff",
        padding: "15px",
        borderRadius: "8px"
    },

    createBtn: {
        background: "#021843",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        padding: "7px 16px",
        fontSize: "13px"
    },

    viewBtn: {
        background: "#021843",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "5px 12px",
        fontSize: "12px"
    },

    editBtn: {
        backgroundColor: "#212529",
        color: "#fff",
        border: "1px solid #212529",
        borderRadius: "4px",
        padding: "6px 12px",
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: 1.5,
        cursor: "pointer"
    },

    modalBackdrop: {
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999
    },

   modal: {
    width: "95%",
    maxWidth: "1400px",
    height: "90vh",
    background: "#fff",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column"
},

modalBody: {
    padding: "20px",
    overflow: "auto",
    flex: 1
},

modalFooter: {
    padding: "15px 20px",
    borderTop: "1px solid #eee",
    display: "flex",
    justifyContent: "flex-end",
    background: "#fff",
    marginTop: "auto"
},

    modalHeader: {
        padding: "15px 20px",
        borderBottom: "1px solid #eee",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },


    closeBtn: {
        border: "none",
        background: "transparent",
        fontSize: "16px"
    },

    label: {
        fontSize: "12px",
        fontWeight: 600,
        marginBottom: "4px"
    },

    addBtn: {
        background: "#021843",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        width: "32px",
        height: "32px"
    },

    deleteBtn: {
        background: "#dc2626",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        width: "32px",
        height: "32px"
    },

    saveBtn: {
        background: "#021843",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        padding: "7px 18px"
    }
};

export default QualityConfiguration;